// ---------------------------------------------------------------------------
// Toggle — accessible on/off switch
// ---------------------------------------------------------------------------

interface ToggleProps {
  id?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  /** Show label to the left of the toggle (default: left) */
  labelPosition?: "left" | "right";
  disabled?: boolean;
}

export function Toggle({
  id,
  checked,
  onChange,
  label,
  labelPosition = "left",
  disabled = false,
}: Readonly<ToggleProps>) {
  const toggle = (
    <button
      id={id}
      type="button"
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
        checked ? "bg-brand-primary" : "bg-surface-tertiary"
      } ${disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}`}
    >
      <span
        className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
          checked ? "translate-x-6" : "translate-x-1"
        }`}
      />
    </button>
  );

  if (!label) return toggle;

  return (
    <div className="flex items-center justify-between">
      {labelPosition === "left" && (
        <label htmlFor={id} className="text-sm font-medium text-content-secondary">
          {label}
        </label>
      )}
      {toggle}
      {labelPosition === "right" && (
        <label htmlFor={id} className="text-sm font-medium text-content-secondary">
          {label}
        </label>
      )}
    </div>
  );
}
